/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */
'use strict';
var priceCollection = require('../collections/pricemanager.collection').getInstance();
var pricebreakdownAttributes = require('../enums/pricebreakdown_item_attribute.enum');
var Mixin = require('./mixin');

module.exports = new Mixin({
    addItemToPricemanagerCollection: function(item) {
        return priceCollection.addItem(item);
    },

    removeItemFromPricemanagerCollectionByType: function(type) {
        priceCollection.removeItemByType(type);

        return this;
    },

    removeItemFromPricemanagerCollection: function(pbItem) {
        if (!Odigeo._.isNull(pbItem)) {
            priceCollection.removeItem(pbItem);
        }

        return this;
    },

    addItemToPricemanagerCollectionIfNotExists: function(item) {
        var conceptKey = item.get(pricebreakdownAttributes.CONCEPT_KEY);
        var existingItem = priceCollection.getPriceBreakdownItemByConceptKey(conceptKey);
        if (!existingItem) {
            existingItem = this.addItemToPricemanagerCollection(item);
        }
        return existingItem;
    },

    removeItemFromPricemanagerCollectionByPolicy: function(policy) {
        const existingItem = priceCollection.getPriceBreakdownItemByPolicyOrId(policy);
        if (existingItem) {
            this.removeItemFromPricemanagerCollection(existingItem);
        }
    },
});
